import {
  UserAvatarPopoverStoreSlice,
  UserAvatarPopoverStoreState,
} from './types';
import { reduxKey } from './constants';

function getState(state: UserAvatarPopoverStoreState) {
  return state[reduxKey] || {};
}

export function getTooltipState(
  state: UserAvatarPopoverStoreState,
  username: string
): UserAvatarPopoverStoreSlice {
  return (username && getState(state)[username.toLowerCase()]) || {};
}

export function getIsInitialized(
  state: UserAvatarPopoverStoreState,
  username: string
): boolean {
  return (
    Boolean(username) &&
    state[reduxKey] !== undefined &&
    state[reduxKey][username.toLowerCase()] !== undefined
  );
}

export function getIsLoading(
  state: UserAvatarPopoverStoreState,
  username: string
): boolean | undefined {
  return getTooltipState(state, username).isLoading;
}
